import { B as f } from "./buffer-BjzLorpP.js";
const i = () => {
  const t = {
    end: () => {
    },
    spanContext: () => ({
      traceId: "",
      spanId: "",
      traceFlags: 0
    }),
    setAttribute: (r, e) => t,
    setAttributes: (r) => t,
    addEvent: (r, e, s) => t,
    addLinks: (r) => t,
    setStatus: (r) => t,
    recordException: () => {
    },
    addLink: () => t,
    updateName: () => t,
    isRecording: () => !1
  };
  return t;
};
function o(t, r, e) {
  if (typeof e == "function")
    return e;
  if (typeof r == "function")
    return r;
  if (typeof t == "function")
    return t;
}
class l extends f {
  start() {
    return this._sdk.start();
  }
  stop() {
    return this._sdk.stop();
  }
  recordGauge(r) {
    return this._bufferCall("recordGauge", [r]);
  }
  recordCount(r) {
    return this._bufferCall("recordCount", [r]);
  }
  recordIncr(r) {
    return this._bufferCall("recordIncr", [r]);
  }
  recordHistogram(r) {
    return this._bufferCall("recordHistogram", [r]);
  }
  recordUpDownCounter(r) {
    return this._bufferCall("recordUpDownCounter", [r]);
  }
  // The callback holds the caller's own work, so it must never be buffered:
  // deferring it would replay that work at an arbitrary later time, or drop it.
  startSpan(r, e, s, a) {
    var n;
    return this._isLoaded ? this._bufferCall("startSpan", [r, e, s, a]) : (n = o(e, s, a)) == null ? void 0 : n(i());
  }
  startManualSpan(r, e, s, a) {
    var n;
    return this._isLoaded ? this._bufferCall("startManualSpan", [r, e, s, a]) : (n = o(e, s, a)) == null ? void 0 : n(i());
  }
  register(r, e) {
    return this._bufferCall("register", [r, e]);
  }
  recordLog(r, e, s) {
    return this._bufferCall("recordLog", [r, e, s]);
  }
  recordError(r, e, s, a, n) {
    return this._bufferCall("recordError", [
      r,
      e,
      s,
      a,
      n
    ]);
  }
  setLDContextKeyAttributes(r) {
    return this._bufferCall("setLDContextKeyAttributes", [r]);
  }
  getLDContextKeyAttributes() {
    return this._bufferCall("getLDContextKeyAttributes", []);
  }
}
let u;
typeof globalThis != "undefined" ? globalThis.LDObserve ? u = globalThis.LDObserve : (u = new l(), globalThis.LDObserve = u) : u = new l();
export {
  u as L,
  i as g
};
//# sourceMappingURL=LDObserve-DhF3vCDR.js.map
